module.exports = __webpack_public_path__ + "4171fd8c7f8017cad65e5babf2f1c0dd.svg";